import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import image1 from "../../../assets/farm/img_14.jpg";

const Industry = () => {
  return (
    <Grid container marginTop={{ xs: "25%", sm: "2%" }}>
      <Grid
        item
        xs={12}
        margin={{ xs: "15% 0%", sm: "4% 0%" }}
        display={{ xs: "none", sm: "inline" }}
      >
        <Divider color={"#fff"} />
      </Grid>
      <Grid item xs={12} sm={4} paddingRight={{ xs: "0%", sm: "2%" }}>
        <Typography
          variant="body1"
          color={"#4f4f4f"}
          paragraph
          lineHeight={1.5}
        >
          Nigeria’s aquaculture industry is largely untapped, and is
          characterized by poor access to soft credit facilities, lack of the
          requisite technical skills and the unavailability of good quality and
          moderately priced fish seeds and feeds, all of which mitigates the
          sector’s growth and development. The total annual fish demand in
          Nigeria is estimated at 3.4 million metric tons. About 40% of this
          demand is met domestically resulting in an annual import expenditure
          of over N125billion ($625 million) on fish.
        </Typography>
        <Typography
          variant="body1"
          color={"#4f4f4f"}
          paragraph
          lineHeight={1.5}
        >
          An expansion in the domestic production of fish will create employment
          and entrepreneurial opportunities for unemployed youth and women, and
          this can be achieved by building their skill set (technical and
          entrepreneurial), teaching them basic principles of civic development,
          providing access to financial resources, providing market linkages and
          supporting them through mentorship.
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        paddingRight={{ xs: "0%", sm: "3%" }}
        paddingTop={{ xs: "3%", sm: "0%" }}
        display={{ xs: "block", sm: "none" }}
      >
        <Box
          component="img"
          height={{ xs: "60vh", sm: "70vh" }}
          paddingBottom={{ xs: "7%", sm: "0%" }}
          sx={{
            objectFit: "cover",
            position: "relative",
            overflow: "hidden",
            borderRadius: "5px",
            width: "100%",
          }}
          src={image1}
          alt={"about-image"}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        paddingRight={{ xs: "0%", sm: "2%" }}
        paddingTop={{ xs: "1%", sm: "0%" }}
      >
        <Typography variant="body1" color={"#4f4f4f"} paragraph>
          Aquatic Hub Afrique Network (AHAN) was established for the purpose of
          capacity building in Agriculture with its primary focus on
          Aquaculture. AHAN is an organization established with the aim of
          creating and expanding employment and entrepreneurial opportunities
          for target groups along the aquaculture value chain. It adopts an
          empowerment model that focuses on building core competencies of
          individuals (youth, women, aged, retirees, etc.) to profitably manage
          businesses along the aquaculture value chain; AHAN also engages in
          civic development and mentorship of trainees. Aquatic Hub Afrique
          Network is a member of the United Nations Private Sector Advisory
          Group.
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4} display={{ xs: "none", sm: "inline" }}>
        <Box
          component="img"
          height={{ xs: "30vh", sm: "500px" }}
          sx={{
            objectFit: "cover",
            position: "relative",
            overflow: "hidden",
            borderRadius: "5px",
            width: "100%",
          }}
          src={image1}
          alt={"about-image"}
        />
      </Grid>
    </Grid>
  );
};

export default Industry;
